/* --- STATE --- */
import { WorkflowRead } from '@ariksa/awm/api';
import {
  CloudAccountGetResponse,
  OnboardingConfigResponse,
} from '@ariksa/cloud-account/api';
import {
  CheckDetailResponse,
  CheckListResponse,
  EnvironmentRead,
  Remediation,
} from '@ariksa/compliance-policies/api';
import { IPagedQueryState } from 'services/utils/PagedQueryState';
import { IQueryState } from 'services/utils/QueryState';
import { Dict } from 'types/utils';

import { ScanVaultScannerInfo } from 'api/scan-vault/client';
import { ApiCallStateWithPagination, ApiCallStatus } from 'api/types';
import { ApiCallState } from 'api/types';
import { PageInfo } from 'app/components';

export interface CloudAccountsState {
  accounts: IPagedQueryState<CloudAccountGetResponse[]>;
  identityProviderAccounts: IQueryState<CloudAccountGetResponse[]>;
  dataAccessManagement: IQueryState<any>;
  memberAccounts: IPagedQueryState<CloudAccountGetResponse[]>;

  management_account_uuid: string;
  accountRediscovery: IQueryState<any>;
  isEdit: boolean;
  accountDetails: IQueryState<CloudAccountGetResponse>;
  assetSummary: ApiCallState<AssetSummaryEntry[]>;
  current_snapshot_id: string;
  snapshotTasks: ApiCallStatus & {
    results: Record<string, any>;
    total: number;
    pagination: PageInfo;
  };
  apiCallStatus: IQueryState<any>;
  refreshAccount: WithAccountUuid;
  onboardMemberAccount: WithAccountUuid;
  snapshots: ApiCallStateWithPagination<Dict<any>[]>;

  selectedRow: {
    id: string;
  };

  alertSeverity: ApiCallStatus & {
    total_alerts: number;
    severity_count: Record<string, any>;
  };
  accountSnapshotStatus: IQueryState<WorkflowRead>;
  vulnerabilityScanner: IQueryState<Record<string, ScanVaultScannerInfo[]>>;
  dataScanner: IQueryState<Record<string, any>>;
  accountAction: IQueryState<any>;

  governanceChecklist: IQueryState<CheckListResponse>;
  governanceCheckDetails: IQueryState<Record<string, CheckDetailResponse>>;
  governanceCheckRemediation: IQueryState<Record<string, Remediation>>;
  checklistHistory: IQueryState<any>;
  downloadChecklist: IQueryState<Record<string, any>>;

  attachedEnvironments: IQueryState<EnvironmentRead[]>;
  config: IQueryState<OnboardingConfigResponse>;
  updateAccountDiscoveryInterval: IQueryState<any>;
}

export interface WithAccountUuid extends ApiCallStatus {
  uuid: string;
}

export interface GetSnapshotStatusRequestParams {
  accountId: string;
  member?: boolean;
}

export interface AssetSummaryEntry {
  name: string;
  value: number;
}

export interface AccountAlertSeverityProps {
  account_id: string;
  managementAccountUUID?: string;
}

export interface RediscoverInventoryRequestParams {
  uuid: string;
  discoverAll?: boolean;
  regionList?: string;
  serviceList?: string;
}

export type ContainerState = CloudAccountsState;

export type UUID = { uuid: string };

export interface EnableRemediationRequestParams {
  onClose();
  isOpen: boolean;
  account: CloudAccountGetResponse;
}

export const DataPolicyManagementHelp = {
  RegionDataPolicyManagement: 'RegionDataPolicyManagement',
};
